/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { PostHogProvider } from 'posthog-js/react';

import store from '../redux/store';

import { startIntercom } from '~services/IntercomService';
import { apiSetup } from '~config/api';
import Theme from '~config/MaterialUIStyles/Theme';
import { isGDPRCountry } from '~utils/cookieSettings';
import { PUBLIC_POSTHOG_KEY, PUBLIC_POSTHOG_HOST } from '~constants/environment';

import '../scss/application.scss';

import Routes from './components/Routes';
import ErrorBoundary from './components/ErrorBoundary/index';
import {
  loadAnalyticsScripts,
  renderHeadAnalyticsScripts,
  renderPushAlert,
  weglotScript,
  hasAnalyticsConsent
} from './utils';
import { StructuredData } from './components/StructuredData';

const options = {
  api_host: PUBLIC_POSTHOG_HOST
};
class App extends Component {
  componentDidMount() {
    apiSetup(store.dispatch);
    startIntercom();
    loadAnalyticsScripts();
  }

  render() {
    return (
      <ThemeProvider theme={Theme}>
        {(hasAnalyticsConsent() || !isGDPRCountry()) && renderHeadAnalyticsScripts()}
        {renderPushAlert()}
        {weglotScript()}
        <PostHogProvider apiKey={PUBLIC_POSTHOG_KEY} options={options}>
          <Provider store={store}>
            <StructuredData />
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </Provider>
        </PostHogProvider>
      </ThemeProvider>
    );
  }
}

App.defaultProps = {
  loading: false
};

export default App;
